export const EVIDENCE_FILE_MAX_SIZE_BYTES = 100 * 1024 * 1024;
export const EVIDENCE_FILE_MAX_SIZE_LABEL = '100MB';

export const EVIDENCE_FILE_SUPPORTED_EXTENSIONS = [
  '.pdf',
  '.docx',
  '.doc',
  '.xlsx',
  '.xls',
  '.csv',
  '.txt',
  '.md',
  '.mdx',
  '.json',
  '.png',
  '.jpg',
  '.jpeg',
  '.gif',
  '.webp',
] as const;

export const EVIDENCE_FILE_ACCEPT = EVIDENCE_FILE_SUPPORTED_EXTENSIONS.join(',');

export const EVIDENCE_FILE_TYPES_DESCRIPTION =
  'PDF, Word (DOC/DOCX), Excel (XLS/XLSX), CSV, Text, Markdown (MD/MDX), JSON, and images (PNG, JPG, GIF, WebP)';

export function isEvidenceFileExtensionSupported(filename: string): boolean {
  const lastDotIndex = filename.lastIndexOf('.');
  if (lastDotIndex < 0) return false;

  const ext = filename.slice(lastDotIndex).toLowerCase();
  return EVIDENCE_FILE_SUPPORTED_EXTENSIONS.includes(
    ext as (typeof EVIDENCE_FILE_SUPPORTED_EXTENSIONS)[number]
  );
}

export function isEvidenceFileSizeValid(size: number): boolean {
  return size <= EVIDENCE_FILE_MAX_SIZE_BYTES;
}

type FileWithSize = { name: string; size: number };

export function splitEvidenceFilesBySize<T extends FileWithSize>(files: T[]) {
  const oversizedFiles = files.filter((file) => !isEvidenceFileSizeValid(file.size));
  const validFiles = files.filter((file) => isEvidenceFileSizeValid(file.size));

  return { oversizedFiles, validFiles };
}

export function getEvidenceFileTooLargeMessage(filename?: string): string {
  if (filename) {
    return `"${filename}" exceeds the ${EVIDENCE_FILE_MAX_SIZE_LABEL} limit for evidence file uploads.`;
  }

  return `Evidence files must be ${EVIDENCE_FILE_MAX_SIZE_LABEL} or smaller.`;
}

export function getEvidenceFilesTooLargeMessage(filenames: string[]): string {
  if (filenames.length === 1) {
    return getEvidenceFileTooLargeMessage(filenames[0]);
  }

  return `These files exceed the ${EVIDENCE_FILE_MAX_SIZE_LABEL} limit for evidence file uploads: ${filenames.join(', ')}.`;
}
